<template>
  <Modal title="添加退款记录" v-model="visible" width="1000px">
    <Form ref="insertUserForm" class="form" :label-width="110"
          :model="formData" :rules="rules" >
      <Row>
        <Col :span="6" >
          <Form-item label="学员ID" prop="uid">
            <Input
              v-model.number="formData.uid" @on-blur="searchUserInfo(false)"></Input>
          </Form-item>
        </Col>
        <Col :span="6" >
          <Form-item label="学员姓名">
            <Input
              v-model="user.nickname" :readonly="true"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="手机号" >
            <Input v-model="user.mobile" :readonly="true"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="课程顾问">
            <Input v-model="user.adviserName" :readonly="true"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="学习导师">
            <Input v-model="user.studyAdviserName" :readonly="true"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item :label="lastTeacherLabel" prop="lastTchId" :required="refundTeacherRequired">
            <Input v-if="!canSave" v-model="formData.lastTchName" :readonly="true"></Input>
            <TeacherSelect v-else :category="[1,2,3]" v-model="formData.lastTchId"
                           :label="formData.lastTchName" @on-change="onTchChange"></TeacherSelect>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="对应老师外管">
            <Input v-model="formData.tchAdviserName" :readonly="true"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="注册渠道">
            <Input v-model="formData.regChannel" :readonly="true"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="课时费" prop="lessonFee">
            <Input v-model.number="formData.lessonFee" @on-change="onFeeFieldChange"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="礼品费" prop="giftFee">
            <Input v-model.number="formData.giftFee" @on-change="onFeeFieldChange"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="手续费" prop="serviceFee">
            <Input v-model.number="formData.serviceFee" @on-change="onFeeFieldChange"></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="实际退款金额" prop="actualRefundAmount">
            <Input v-model.number="formData.actualRefundAmount" ></Input>
          </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="其他扣款" prop="otherAmount">
            <Input v-model.number="formData.otherAmount" @on-change="onFeeFieldChange"></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="退款账号" prop="refundAccount">
            <Input v-model="formData.refundAccount" ></Input>
          </Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="退款原因" prop="refundReason">
            <Input v-model="formData.refundReason" ></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="退款原因分类" prop="refundReasonCategory">
            <Select v-model="formData.refundReasonCategory" placeholder="请选择" clearable>
              <Option :value="1">外教原因</Option>
              <Option :value="2">学导原因</Option>
              <Option :value="3">销售原因</Option>
              <Option :value="4">技术原因</Option>
              <Option :value="5">产品原因</Option>
              <Option :value="6">学生客观原因</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item label="备注" prop="refundRemark">
            <Input v-model="formData.refundRemark" ></Input>
          </Form-item>
        </Col>
        <Col :span="11">
          <Form-item prop="orderId"></Form-item>
          <Form-item prop="courseUnitPrice" style="display:none"></Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" v-if="canSave" :loading="loadingInsertUser" @click="insert">保存</Button>
    </div>
    <el-checkbox-group v-model="checkedList" @change="handleCheckedOrderListChange">
    <table class="track-list">
      <thead>
      <tr style="font-size: 12px;">
        <th width="10%">订单编号</th>
        <th width="10%">订单金额</th>
        <th width="10%">订单课时</th>
        <th width="10%">教材金额</th>
        <th width="10%">开票金额</th>
        <th width="10%">合计课节</th>
        <th width="10%">累计消耗</th>
        <th width="10%">补课次数</th>
        <th width="10%">课时单价</th>
        <th width="10%">消耗</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in dataList">
          <td><el-checkbox :label="item.orderSn"></el-checkbox></td>
          <td>{{item.orderAmount}}</td>
          <td>{{item.orderCourseNum}}</td>
          <td>{{item.textAmount}}</td>
          <td>{{item.invoiceAmount}}</td>
          <td :rowspan="index == 0?colSpan:0" :hidden="index != 0">{{item.taotalCourseNum}}</td>
          <td :rowspan="index == 0?colSpan:0" :hidden="index != 0">{{item.costCourseNum}}</td>
          <td :rowspan="index == 0?colSpan:0" :hidden="index != 0">{{item.makeupNum}}</td>
          <td :rowspan="index == 0?colSpan:0" :hidden="index != 0">
            <Input v-model.number="formData.courseUnitPrice" :readonly="!canSave" @on-change="onUnitPriceChange"></Input>
          </td>
          <td :rowspan="index == 0?colSpan:0" :hidden="index != 0">{{displayCostAmount}}</td>
        </tr>
      </tbody>
    </table>
    </el-checkbox-group>
    <!--<Table :data="dataList" :columns="title" listUrl=""></Table>-->
  </Modal>
</template>
<script>
  export default {
    name: 'RefundInsertModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      id: {
        type: Number,
        default: null
      },
      successCallback: {
        type: Function
      },
      canSave: {
        type: Boolean,
        default: true
      },
      orderNum: {
        type: Object,
      }
    },
    data () {
      return {
        visible: this.value,
        loadingInsertUser: false,
        user: {},
        formData: {
          id: '',
          uid: '',
          otherAmount: '',
          lessonFee: '',
          giftFee: '',
          serviceFee: '',
          actualRefundAmount: '',
          courseUnitPrice: 180,
          lastTchId: null,
          lastTchName: '',
          tchAdviserName: '',
          regChannel: '',
          refundAccount: '原路退回',
          refundReason: '',
          refundReasonCategory: null,
          refundRemark: '',
          orderId: ''
        },
        checkedList: [],
        dataList: [],
        rules: {
          uid: [
            { type: 'integer', required: true, message: '学生id不能为空', trigger: 'blur' },
          ],
          otherAmount: [
            { type: 'number', required: true, message: '其他扣款不能为空', trigger: 'blur' },
          ],
          lessonFee: [
            { type: 'number', required: true, message: '课时费不能为空', trigger: 'blur' },
          ],
          giftFee: [
            { type: 'number', required: true, message: '礼品费不能为空', trigger: 'blur' },
          ],
          serviceFee: [
            { type: 'number', required: true, message: '手续费不能为空', trigger: 'blur' },
          ],
          actualRefundAmount: [
            { type: 'number', required: true, message: '实际退款金额不能为空', trigger: 'blur' },
          ],
          courseUnitPrice: [
            { type: 'number', required: true, message: '课时单价不能为空', trigger: 'blur' },
          ],
          refundAccount: [
            { type: 'string', required: true, message: '退款账号不能为空', trigger: 'blur' },
          ],
          refundReason: [
            { type: 'string', required: true, message: '退款原因不能为空', trigger: 'blur' },
          ],
          refundReasonCategory: [
            { type: 'number', required: true, message: '退款原因分类不能为空', trigger: 'change' },
          ],
          orderId: [
            { type: 'string', required: true, message: '请选择订单', trigger: 'blur' }
          ],
          lastTchId: [
            {
              validator: (rule, value, callback) => {
                this.validateRefundTeacher(rule, value, callback)
              },
              trigger: 'change'
            }
          ]
        },
        colSpan: '',
        hiddenTd: 'hiddenTd',
        title: [
          {
            title: '订单编号',
            key: 'orderSn'
          },
          {
            title: '订单金额',
            key: 'orderAmount',
          },
          {
            title: '订单课时',
          },
          {
            title: '合计课节',
          },
          {
            title: '累计消耗(课时)',
          },
          {
            title: '补课次数',
          },
          {
            title: '课时单价',
            render: (h, params) => {
              return h('span', params.row.courseUnitPrice)
            }
          },
          {
            title: '消耗',
            key: 'costAmount'
          },
          {
            title: '教材金额',
            key: 'textAmount',
          },
          {
            title: '开票金额',
            key: 'invoiceAmount',
          },
        ],
      }
    },
    computed: {
      refundTeacherRequired () {
        return Number(this.formData.refundReasonCategory) === 1
      },
      lastTeacherLabel () {
        if (this.refundTeacherRequired) {
          return '退款老师'
        }
        return '最后一节课老师'
      },
      displayCostAmount () {
        if (!this.dataList || this.dataList.length === 0) {
          return ''
        }
        let first = this.dataList[0]
        let price = this.formData.courseUnitPrice
        if (price === '' || price == null) {
          return first.costAmount
        }
        let num = Number(first.costCourseNum || 0)
        return this.round2(Number(price) * num)
      }
    },
    methods: {
      emptyNum (val) {
        if (val === '' || val == null || isNaN(Number(val))) {
          return 0
        }
        return Number(val)
      },
      round2 (val) {
        return Math.round(this.emptyNum(val) * 100) / 100
      },
      findSelectedOrders () {
        let orders = []
        if (!this.formData.orderId || !this.dataList || this.dataList.length === 0) {
          return orders
        }
        let ids = String(this.formData.orderId).split(',')
        let i
        for (i = 0; i < ids.length; i++) {
          let j
          for (j = 0; j < this.dataList.length; j++) {
            if (this.dataList[j] && this.dataList[j].orderSn === ids[i]) {
              orders.push(this.dataList[j])
              break
            }
          }
        }
        return orders
      },
      selectedOrderAmount () {
        let orders = this.findSelectedOrders()
        let amount = 0
        let i
        for (i = 0; i < orders.length; i++) {
          amount += this.emptyNum(orders[i].orderAmount)
        }
        return amount
      },
      selectedOrderCourseNum () {
        let orders = this.findSelectedOrders()
        let num = 0
        let i
        for (i = 0; i < orders.length; i++) {
          num += this.emptyNum(orders[i].orderCourseNum)
        }
        return num
      },
      costCourseNum () {
        if (!this.dataList || this.dataList.length === 0) {
          return 0
        }
        return this.emptyNum(this.dataList[0].costCourseNum)
      },
      recalcLessonFee () {
        this.formData.lessonFee = this.round2(this.emptyNum(this.formData.courseUnitPrice) * this.costCourseNum())
      },
      recalcActualRefund () {
        if (this.findSelectedOrders().length === 0) {
          return
        }
        this.formData.actualRefundAmount = this.round2(
          this.selectedOrderAmount() -
          this.emptyNum(this.formData.lessonFee) -
          this.emptyNum(this.formData.giftFee) -
          this.emptyNum(this.formData.serviceFee) -
          this.emptyNum(this.formData.otherAmount)
        )
      },
      applyOrderAutoFill () {
        if (this.findSelectedOrders().length === 0) {
          return
        }
        let hours = this.selectedOrderCourseNum()
        let amount = this.selectedOrderAmount()
        this.formData.courseUnitPrice = hours === 0 ? 0 : this.round2(amount / hours)
        this.recalcLessonFee()
        this.formData.serviceFee = this.round2(amount * 0.03)
        if (!this.formData.refundAccount) {
          this.formData.refundAccount = '原路退回'
        }
        this.recalcActualRefund()
      },
      onUnitPriceChange () {
        this.recalcLessonFee()
        this.recalcActualRefund()
      },
      onFeeFieldChange () {
        this.recalcActualRefund()
      },
      handleCheckedOrderListChange (value) {
        if (value && value.length > 0) {
          this.formData.orderId = value.join(',')
          this.applyOrderAutoFill()
        } else {
          this.formData.orderId = ''
        }
      },
      selectedHasGift () {
        let orders = this.findSelectedOrders()
        let i
        for (i = 0; i < orders.length; i++) {
          if (orders[i].hasGift) {
            return true
          }
        }
        return false
      },
      validateRefundTeacher (rule, value, callback) {
        if (Number(this.formData.refundReasonCategory) !== 1) {
          callback()
          return
        }
        var idEmpty = value === null || value === undefined || value === '' || Number(value) === 0
        var name = this.formData.lastTchName
        var nameEmpty = name === null || name === undefined || String(name).trim() === ''
        if (idEmpty && nameEmpty) {
          callback(new Error('退款老师不能为空'))
          return
        }
        callback()
      },
      assertGiftFeeIfNeeded () {
        if (!this.selectedHasGift()) {
          return true
        }
        if (this.formData.giftFee === '' || this.formData.giftFee == null || Number(this.formData.giftFee) <= 0) {
          this.$Message.warning('赠送过礼品必须要填写')
          return false
        }
        return true
      },
      searchUserInfo (keepFill) {
        if (!this.formData.uid) {
          return
        }
        let self = this
        self.$http.get('/user/queryById?uid=' + self.formData.uid).then(function (res) {
          if (res.data) {
            self.user = res.data
          }
        })
        if (keepFill !== true) {
          self.$http.get('/financial/refund/fillByUid', { params: { uid: self.formData.uid } }).then(function (res) {
            if (res.data) {
              self.formData.lastTchId = res.data.lastTchId
              self.formData.lastTchName = res.data.lastTchName || ''
              self.formData.tchAdviserName = res.data.tchAdviserName || ''
              self.formData.regChannel = res.data.regChannel || ''
            }
          })
        }
        let path = '/financial/refund/listByUid?uid=' + self.formData.uid
        if (this.orderNum) {
          path += '&orderId=' + this.orderNum
        }
        self.$http.get(path).then(function (res) {
          if (res.data) {
            self.dataList = res.data
            self.setColSpanNum()
          }
        })
      },
      onTchChange (id, name) {
        if (!id) {
          this.formData.lastTchId = null
          this.formData.lastTchName = ''
          this.formData.tchAdviserName = ''
          return
        }
        let self = this
        let cleanName = (name || '').replace(/null/g, '').replace(/undefined/g, '').replace(/\s+/g, ' ').trim()
        self.formData.lastTchId = id
        self.formData.lastTchName = cleanName ? (id + '-' + cleanName) : ''
        self.$http.get('/tch/queryById?tchId=' + id).then(function (res) {
          if (!res.data) {
            return
          }
          self.formData.tchAdviserName = res.data.studyAdviserName || ''
          const first = (res.data.firstName || '').trim()
          const last = (res.data.lastName || '').trim()
          const full = (first + ' ' + last).trim()
          if (full) {
            self.formData.lastTchName = id + '-' + full
          }
        })
      },
      insert () {
        let self = this
        self.loadingInsertUser = true
        self.$refs.insertUserForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingInsertUser = false
            return
          }
          if (!self.assertGiftFeeIfNeeded()) {
            self.loadingInsertUser = false
            return
          }
          let url = ''
          if (self.formData.id) {
            url = '/financial/refund/update'
          } else {
            url = '/financial/refund/insert'
          }
          self.$http.post(url, self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.visible = false
              self.$Message.success('提交成功!')
              self.successCallback()
            }
            self.loadingInsertUser = false
          }).catch(function (e) {
            self.showInsertUserModal = false
            self.loadingInsertUser = false
          })
        })
      },
      setColSpanNum () {
        this.colSpan = this.dataList.length
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      'formData.refundReasonCategory' () {
        this.$nextTick(() => {
          if (this.$refs.insertUserForm) {
            this.$refs.insertUserForm.validateField('lastTchId')
          }
        })
      },
      id (val) {
        let self = this
        if (val) {
          this.formData.id = val
          self.$http.get('/financial/refund/list?id=' + val).then(function (res) {
            if (res.data.data.length > 0) {
              let data = res.data.data[0]
              self.formData = data
              self.formData.id = data.id
              self.formData.uid = data.uid
              self.formData.otherAmount = data.otherAmount
              self.formData.lessonFee = data.lessonFee
              self.formData.giftFee = data.giftFee
              self.formData.serviceFee = data.serviceFee
              self.formData.actualRefundAmount = data.actualRefundAmount
              self.formData.courseUnitPrice = data.courseUnitPrice != null ? data.courseUnitPrice : 180
              self.formData.lastTchId = data.lastTchId
              self.formData.lastTchName = data.lastTchName
              self.formData.tchAdviserName = data.tchAdviserName
              self.formData.regChannel = data.regChannel
              self.formData.refundAccount = data.refundAccount
              self.formData.refundReason = data.refundReason
              self.formData.refundReasonCategory = data.refundReasonCategory
              self.formData.refundRemark = data.refundRemark
              self.searchUserInfo(true)
            }
          })
        }
      },
      visible (val) {
        this.queryParam = {}
        this.user = {}
        this.dataList = []
        this.checkedList = []
        this.formData = {
          id: '',
          uid: null,
          otherAmount: '',
          lessonFee: '',
          giftFee: '',
          serviceFee: '',
          actualRefundAmount: '',
          courseUnitPrice: 180,
          lastTchId: null,
          lastTchName: '',
          tchAdviserName: '',
          regChannel: '',
          refundAccount: '原路退回',
          refundReason: '',
          refundReasonCategory: null,
          refundRemark: '',
          orderId: ''
        }
        if (val === true) {
        } else {
          this.$emit('on-close', val)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RefundInsertModal.vue?0b810d79